module.exports = "<div class=\"tabs-component vertical-list col-md-12\">\n  <ul>\n    <li *ngFor=\"let info of routeInfo\" [ngClass]=\"info.ref[0] === '/analytics/snapshot' ? 'go-to-analytics' : info.ref[0]\" [routerLink]=\"info.ref\" [routerLinkActive]=\"'selected'\" [routerLinkActiveOptions]=\"{exact: !activeForChildren}\">{{ info.title }}</li>\n  </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/tabs/router-tabs/router-tabs.component.html
// module id = ../../../../../src/app/shared/tabs/router-tabs/router-tabs.component.html
// module chunks = 2